import { useEffect } from 'react'

// Count visible, recently active lesson time only. No home, library, parent or QA time.
export function useLessonClock(active: boolean, record: (seconds: number) => void) {
  useEffect(() => {
    if (!active) return
    let last = Date.now()
    let lastInteraction = last
    let visible = document.visibilityState === 'visible'
    let pendingMs = 0
    const flush = () => {
      const now = Date.now()
      if (visible) {
        const until = Math.min(now, lastInteraction + 60_000)
        pendingMs += Math.max(0, until - last)
        const seconds = Math.floor(pendingMs / 1000)
        if (seconds) { record(seconds); pendingMs -= seconds * 1000 }
      }
      last = now
    }
    const interact = () => { flush(); lastInteraction = Date.now() }
    const visibility = () => { flush(); visible = document.visibilityState === 'visible'; lastInteraction = Date.now() }
    const timer = window.setInterval(flush, 5000)
    window.addEventListener('pointerdown', interact)
    window.addEventListener('keydown', interact)
    document.addEventListener('visibilitychange', visibility)
    window.addEventListener('pagehide', flush)
    return () => {
      flush()
      window.clearInterval(timer)
      window.removeEventListener('pointerdown', interact)
      window.removeEventListener('keydown', interact)
      document.removeEventListener('visibilitychange', visibility)
      window.removeEventListener('pagehide', flush)
    }
  }, [active, record])
}
